/** Shared movement commands for table row menus and Pitch controls. */
import {
  ArrowDownIcon,
  ArrowUpIcon,
  ChevronsDownIcon,
  ChevronsUpIcon,
} from "lucide-react-native";
import type { WatchlistMoveDestination } from "../components/molecules/WatchlistOrderControls";

/**
 * Build bounded movement commands without duplicating table/Pitch behavior.
 * @param onMove - Apply a movement command.
 * @param isFirst - Player is first in the applicable order.
 * @param isLast - Player is last in the applicable order.
 * @param paused - An explicit column sort pauses all movement.
 * @param showShortcuts - Show direct shortcuts only where the focused row handles them.
 * @returns Menu commands with boundaries and permission state applied.
 */
export const watchlistMoveMenuItems = (
  onMove: (destination: WatchlistMoveDestination) => void,
  isFirst: boolean,
  isLast: boolean,
  paused = false,
  showShortcuts = false
) => [
  {
    id: "top",
    keyboardShortcut: showShortcuts ? "⌥↑" : undefined,
    label: "Move to top",
    icon: ChevronsUpIcon,
    disabled: paused || isFirst,
    onPress: () => onMove("top"),
  },
  {
    id: "up",
    keyboardShortcut: showShortcuts ? "↑" : undefined,
    label: "Move up",
    icon: ArrowUpIcon,
    disabled: paused || isFirst,
    onPress: () => onMove("up"),
  },
  {
    id: "down",
    keyboardShortcut: showShortcuts ? "↓" : undefined,
    label: "Move down",
    icon: ArrowDownIcon,
    disabled: paused || isLast,
    onPress: () => onMove("down"),
  },
  {
    id: "bottom",
    keyboardShortcut: showShortcuts ? "⌥↓" : undefined,
    label: "Move to bottom",
    icon: ChevronsDownIcon,
    disabled: paused || isLast,
    onPress: () => onMove("bottom"),
  },
];
